<template>
	<div :id="'group'+ index" class="panel hide panel-default position-relative" style="min-height:275px;">
		<div class="panel-heading">
			<div class="row">
				<div class="col-md-6 text-right">
					<label :for="'group'+ index +'-name'">Custom Group Name:</label>
				</div>
				<div class="col-md-6">
					<input type="text" 
						   :name="'group'+ index +'-name'"
						   :id="'group'+ index +'-name'"
						   :onkeyup="'groupCharacterLimit('+index+')'"
						   class="form-control"
						   style="color:black"
						   v-model="group_name"
					/>
				</div>
			</div>
			<div class="row" :id="'group'+index+'-info text-center'" style="text-align:center;">
				<span :id="'group' + index + '-hospitalcount'" class="hospcount text-center" style="text-align:center;"></span>
				<br />
				<span :id="'group'+index +'-charcount'" class="charcount text-center" style="display:none;">
					<span class="glyphicon glyphicon-alert" aria-hidden="true"></span>
					Custom Group names over 16 characters may not display
				</span>
			</div>
		</div>
		<div class="panel-body " :id="'group'+ index + '-inputs'" style="margin-bottom: 25px;">
			<!-- Inputs -->
			<input type="hidden" :name="'group'+ index +'-hidden'" :id="'group'+ index +'-hidden'"   value="1" />
			<input type="hidden" :id="'group'+ index +'-numhosp'" class="numhosp" v-model="group_numhosp"/>

			<!-- CAHID -->
			<div class="row hide" :id="'group'+ index +'-cahid-div'">
				<div class="col-md-6 text-right">
					<label :for="'group'+ index + '-cahid'">CAHID:</label>
				</div>
				<div class="col-md-6">
					<input type="text" :name="'group'+ index + '-cahid'" :id="'group'+ index + '-cahid'" readonly class="form-control" v-model="group_cahid"/>
				</div>
			</div>

			<!-- separating the group questions from the hospital questions for hide/show -->
			<div :id="'group'+ index +'-group-questions'">

				<!-- Geography -->
				<div class="row">
					<div class="col-md-6 text-right">
						<label :for="'group'+index+ '-geography'" >Geography</label>
					</div>
					<div class="col-md-6">
						<select 
							:name="'group'+index+ '-geography'" 
							:id="'group'+index+ '-geography'" 
							onchange="setGeo(this); "
							v-model="group_geography"
						>
							<option value="state">State</option>
							<option value="region">Region</option>
							<option value="national">National</option>
						</select>
					</div>
				</div>


				<div class="row hide" :id="'group' + index + '-geography-state-row'" >
					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-geography-state'" >State</label>
					</div>
					
					<div class="col-md-6" >
						<!-- State Geography -->
						<select 
							:name="'group' + index + '-geography-state'"
							:id="'group' + index + '-geography-state'" 
							@change="getCount" 
							v-model="group_geography_state"
						>
							<option value="0">All</option>
							<option  v-for="(state, key, index) in states" :key="key" :value="state"> {{ state }}
							</option>
						</select>
					</div>
				</div>

				<div class="row hide" :id="'group' + index + '-geography-region-row'" >
					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-geography-region'" >Region</label>
					</div>
					<div class="col-md-6">
						<!-- Region Geography -->
						<select 
							:name="'group' + index + '-geography-region'" 
							:id="'group' + index + '-geography-region'" 
							@change="getCount" 
							v-model="group_geography_region"
						>
							<option value="0">All</option>
							<option value="1">Northeast</option>
							<option value="3">South</option>
							<option value="2">Midwest</option>
							<option value="4">West</option>
						</select>
					</div>
				</div>

				<div class="row hide" :id="'group' + index + '-geography-national-row'" >

					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-geography-national'" >National</label>
					</div>
					
					<div class="col-md-6">
						<!-- National Geography -->
						<select 
							:name="'group' + index + '-geography-national'" 
							:id="'group' + index + '-geography-national'" 
							@change="getCount" 
							v-model="group_geography_national"
						>
							<option value="0">All</option>
						</select>
					</div>
				</div>

				<!-- Net Patient Revenue -->
				<div class="row">
					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-netpatrev'">Net Patient Revenue:</label>
					</div>
					<div class="col-md-6">
						<select 
							:name="'group' + index + '-netpatrev'" 
							:id="'group' + index + '-netpatrev'"
							@change="getCount" 
							v-model="group_netpatrev"
						
						>
							<option value="0">All</option>
							<option value="1">Under 10M</option>
							<option value="2">$10-$20M</option>
							<option value="3">Over 20M</option>
						</select>
					</div>
				</div>

				<!-- Rural Healthcare Clinic -->
				<div class="row">
					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-ruralclinic'">Rural Health Clinic:</label>
					</div>
					<div class="col-md-6">
						<select 
							:name="'group' + index + '-ruralclinic'" 
							:id="'group' + index + '-ruralclinic'"
							@change="getCount" 
							v-model="group_ruralclinic"
						
						>
							<option value="0">All</option>
							<option value="1">Yes</option>
							<option value="2">No</option>
						</select>
					</div>
				</div>

				<!-- Long-Term Care -->
				<div class="row">
					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-longtermcare'">Long-Term Care:</label>
					</div>
					<div class="col-md-6">
						<select 
							:name="'group' + index + '-longtermcare'" 
							:id="'group' + index + '-longtermcare'"
							@change="getCount" 
							v-model="group_longtermcare"
						
						>
							<option value="0">All</option>
							<option value="1">Yes</option>
							<option value="2">No</option>
						</select>
					</div>
				</div>

				<!-- Government Owned -->
				<div class="row">
					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-govtowned'">Government Owned:</label>
					</div>
					<div class="col-md-6">
						<select 
							:name="'group' + index + '-govtowned'" 
							:id="'group' + index + '-govtowned'"
							@change="getCount" 
							v-model="group_govtowned"
						
						>
							<option value="0">All</option>
							<option value="1">Yes</option>
							<option value="2">No</option>
						</select>
					</div>
				</div>
				<!-- System -->
				<div class="row ">
					<div class="col-md-6 text-right">
						<label :for="'group' + index + '-system'">System:</label>
					</div>
					<div class="col-md-6">
						<select 
							:name="'group' + index + '-system'" 
							:id="'group' + index + '-system'"
							@change="getCount" 
							v-model="group_system"
						
						>
							<option value="0">All</option>
							<option value="1">Yes</option>
							<option value="2">No</option>
						</select>
					</div>
				</div>

				<!-- Data Year -->
					<div class="row" v-if="chartType == 'bar'" >
						<div class="col-md-6 text-right">
							<label :for="'group' + index + '-year'">Data from Year:</label>
						</div>
						<div class="col-md-6">
							<select 
								:name="'group' + index + '-year'" 
								:id="'group' + index + '-year'"
								@change="getCount" 
								v-model="group_year"

							>
							<option  v-for="(year) in years" :key="year" :value="year"> {{ year }}
							</option>
							
							</select>
						</div>
					</div>
			</div>

			<div :id="'group'+ index +'-group-questions-year'" class="hide">
				<!-- Data Year -->
					<div class="row mt-1" v-if="chartType == 'bar'" >
						<div class="col-md-6 text-right">
							<label :for="'group' + index + '-year-2'">Data from Year:</label>
						</div>
						<div class="col-md-6">
							<select 
								:name="'group' + index + '-year'" 
								:id="'group' + index + '-year-2'"
								

							>
							<option  v-for="(year) in years" :key="year" :value="year" :selected="year === props.defaultYear"> {{ year }}
							</option>
							
							</select>
						</div>
					</div>
			</div>
		</div>
		<div  style="position: relative; bottom: 0px; width: 100%;">
				<div :id="'group' + index + '-deletebtn'" class="w-100 text-right">
					<button class="btn btn-default btn-sm" type="button" id="'group' + index: + '-deletebutton" :onclick="'deleteGroup('+index+')'" style="margin-bottom:10px; margin-right: 45px;">Delete Group</button>
				</div>
		</div>	
	</div>

</template>

<script type="module">

</script>

<script setup>
import { defineEmits, ref, defineExpose, onMounted } from "vue";  
//const emit = defineEmits(["passGroupData"]); 
let props = defineProps(['index', 'states', 'chartType', 'years', 'defaultYear', 'user', 'indicator'])
const group_name = ref('Custom Group '+props.index);
const group_cahid = ref('');
const group_numhosp = ref(null);
const group_geography = ref('state');
const group_geography_region = ref(0);
const group_geography_state = ref(0);
const group_geography_national = ref(0);
const group_netpatrev = ref(0);
const group_ruralclinic = ref(0);
const group_longtermcare = ref(0);
const group_govtowned = ref(0);
const group_system = ref(0);
const group_year = ref(parseInt(props.defaultYear));

// import { storeToRefs } from 'pinia'
// import { useVisualizationsStore } from '../../stores/vis_store'


// const {  setIndicator , fetchStates} = useVisualizationsStore()
// const { arrstates } = storeToRefs(useVisualizationsStore())

// fetchStates();



const gatherData = () => {  

  const data = {
  	'index': props.index,
  	'group_name': $("#group"+props.index+'-cahid').val() == ""? group_name.value : $('#group'+props.index+'-name').val(),
	'group_cahid': $("#group"+props.index+'-cahid').val() == ""?"":$("#group"+props.index+'-cahid').val(),
	'group_numhosp': group_numhosp.value,
	'group_geography': group_geography.value,
	'group_geography_region': group_geography_region.value,
	'group_geography_state': group_geography_state.value,
	'group_geography_national': group_geography_national.value,
	'group_netpatrev': group_netpatrev.value,
	'group_ruralclinic': group_ruralclinic.value,
	'group_longtermcare': group_longtermcare.value,
	'group_govtowned': group_govtowned.value,
	'group_system': group_system.value,
	'group_year': $("#group"+props.index+'-cahid').val() == ""? group_year.value:$("#group"+props.index+'-year-2').val(),
	'group_hidden': $("#group"+props.index).hasClass("hide")
  };
  return data;

}; 

defineExpose({  
  gatherData  
});

const getCount = () => {

			const rawData = gatherData();
		
			var geo = rawData.group_geography;

			if (geo == "national") {
				var geographystate = 0;
			 	var geographyregion = 0;
			 	var geographynational = rawData.group_geography_national;
			} else if (geo == "region") {
				var geographystate = 0;
			 	var geographyregion = rawData.group_geography_region;
			 	var geographynational = 0;
			} else if (geo == "state" ) {
				var geographystate = rawData.group_geography_state;
			 	var geographyregion = 0;
			 	var geographynational = 0;
			} else {
				var geographystate = rawData.group_geography_state;
			 	var geographyregion = rawData.group_geography_region;
			 	var geographynational = rawData.group_geography_national;
			}
			var data = {
			 geography:rawData.group_geography,
			 "geography-state":geographystate,
			 "geography-region":geographyregion,
			 "geography-national":geographynational,
			 netpatrev:rawData.group_netpatrev,
			 ruralclinic:rawData.group_ruralclinic,
			 longtermcare:rawData.group_longtermcare,
			 govtowned:rawData.group_govtowned,
			 system:rawData.group_system,
			 indicator: props.indicator,
			}
			if (rawData.group_year) {
				data.year = rawData.group_year;
			};
			$.ajax({url: "/count?" + jQuery.param(data), success: function(result){
				if ( props.user.typecode == "hospital" ){
					if (result < 5) {
						var disabled = " <span style='color:red'>(<5, graphing disabled)</span>";
						if($('#submit').length == 0) {
							$('#submit').prop('disabled', true);
						}
						
					}else{
						var disabled = "";
						if($('#submit').length == 0) {
							$('#submit').prop('disabled', false);
						}
					}
				} else if ( props.user.typecode == "state" ){
					if ((result < 5) && (props.user.state != data["geography-state"])) {
						var disabled = " <span style='color:red'>(<5 anonymized, graphing disabled)</span>";
						if($('#submit').length == 0) {
							$('#submit').prop('disabled', true);
						}
						
					}else{
						var disabled = "";
						if($('#submit').length == 0) {
							$('#submit').prop('disabled', false);
						}
					}
				} else {
					if (result == 0) {
						var disabled = " <span style='color:red'>(graphing disabled)</span>";
						if($('#submit').length == 0) {
							$('#submit').prop('disabled', true);
						}
					}else{
						var disabled = "";
						if($('#submit').length == 0) {
							$('#submit').prop('disabled', false);
						}
					}
				}
				var count = result + " Hospitals" + disabled;
				document.getElementById("group"+props.index+"-hospitalcount").innerHTML = count;
				document.getElementById('group'+props.index+'-numhosp').value = result;
				//countListener();
		    }});

};
onMounted(() => {
    	
		getCount();
        
	});

</script>
